import React from 'react';
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AIAssistantCardProps {
  onOpenAssistant: () => void;
}

export const AIAssistantCard: React.FC<AIAssistantCardProps> = ({ onOpenAssistant }) => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="px-4 py-4">
        <div className="flex items-center mb-2">
          <Sparkles className="w-5 h-5 text-[#fabddf] mr-2" />
          <h3 className="text-md font-semibold text-gray-800">
            {t('aiAssistant.card.title')}
          </h3>
        </div>
        <p className="text-sm text-gray-600 mb-3">
          {t('aiAssistant.card.description')}
        </p>
        <div className="flex justify-end">
          <button
            onClick={onOpenAssistant}
            className="bg-[#fabddf] hover:bg-[#fabddf]/90 text-[#2d2f4e] text-sm px-3 py-1.5 rounded-lg font-medium transition-colors"
          >
            {t('aiAssistant.card.button')}
          </button>
        </div>
      </div>
    </div>
  );
}; 